module.exports = __webpack_public_path__ + "static/media/tyre-four.69239b3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-four.png
// module id = 363
// module chunks = 0